export interface ColorPreset {
  name: string;
  backgroundColor: string;
  primaryColor: string;
}

export const COLOR_PRESETS: ColorPreset[] = [
  // Light backgrounds with dark accents
  { name: "Classic", backgroundColor: "#ffffff", primaryColor: "#000000" },
  { name: "Ocean", backgroundColor: "#e8f4f8", primaryColor: "#2b50e0" },
  { name: "Sunset", backgroundColor: "#fef3e2", primaryColor: "#ed3024" },
  { name: "Forest", backgroundColor: "#e8f5e9", primaryColor: "#2e7d32" },
  { name: "Lavender", backgroundColor: "#f3e5f5", primaryColor: "#7b1fa2" },
  { name: "Peach", backgroundColor: "#fce4ec", primaryColor: "#c2185b" },
  { name: "Mint", backgroundColor: "#e0f2f1", primaryColor: "#00695c" },
  { name: "Lemon", backgroundColor: "#fffde7", primaryColor: "#f9a825" },
  { name: "Sky", backgroundColor: "#e3f2fd", primaryColor: "#1565c0" },
  { name: "Coral", backgroundColor: "#fff5f5", primaryColor: "#e53935" },
  { name: "Arctic", backgroundColor: "#eceff1", primaryColor: "#1a237e" },
  { name: "Sage", backgroundColor: "#f1f8e9", primaryColor: "#33691e" },
  { name: "Blush", backgroundColor: "#ffeef2", primaryColor: "#ad1457" },
  { name: "Sand", backgroundColor: "#faf6f0", primaryColor: "#6d4c41" },
  { name: "Canary", backgroundColor: "#ffff8d", primaryColor: "#000000" },
  { name: "Ice", backgroundColor: "#e0ffff", primaryColor: "#006064" },

  // Dark backgrounds with light/bright accents
  { name: "Night", backgroundColor: "#1a1a1a", primaryColor: "#ffffff" },
  { name: "Midnight", backgroundColor: "#0d1b2a", primaryColor: "#ffd700" },
  { name: "Berry", backgroundColor: "#4a148c", primaryColor: "#ffffff" },
  { name: "Emerald", backgroundColor: "#1b5e20", primaryColor: "#ffffff" },
  { name: "Flame", backgroundColor: "#212121", primaryColor: "#ff6d00" },
  { name: "Electric", backgroundColor: "#0a0a0a", primaryColor: "#00e5ff" },
  { name: "Wine", backgroundColor: "#4e0000", primaryColor: "#ffc107" },
  { name: "Slate", backgroundColor: "#37474f", primaryColor: "#4dd0e1" },
];

// The preset rail on the onboarding "Make it yours" step — mirrors the app's
// ONBOARDING_COLOR_PRESETS (mobile/lib/constants/colorPresets.ts; keep in
// sync) padded to a multiple of six with entries from COLOR_PRESETS above so
// the six-wide grid fills its last row. Kept separate from COLOR_PRESETS
// (still used by settings) so the two surfaces can evolve independently.
export const ONBOARDING_COLOR_PRESETS: ColorPreset[] = [
  { name: "Wheat + Red", backgroundColor: "#CFC4A3", primaryColor: "#C0271C" },
  { name: "Ice blue + Orange", backgroundColor: "#CDE6E6", primaryColor: "#D96A24" },
  { name: "Pale sage + Brick", backgroundColor: "#D5DEC5", primaryColor: "#A6392E" },
  { name: "Seafoam + Navy", backgroundColor: "#C6E6D9", primaryColor: "#232C6E" },
  { name: "Butter + Violet", backgroundColor: "#E9E58C", primaryColor: "#6E4A82" },
  { name: "Lavender + Forest", backgroundColor: "#E0DAE8", primaryColor: "#2E5738" },
  { name: "Blush + Teal", backgroundColor: "#E8A99E", primaryColor: "#1F6B63" },
  { name: "Sage + Rust", backgroundColor: "#A8BBA0", primaryColor: "#C0491F" },
  { name: "Steel blue + Amber", backgroundColor: "#9DAFC0", primaryColor: "#B87D18" },
  { name: "Peach + Blue", backgroundColor: "#E6C1A0", primaryColor: "#2E6FB5" },
  { name: "Slate teal + Berry", backgroundColor: "#A6BFBB", primaryColor: "#B03A78" },
  { name: "Lilac + Teal", backgroundColor: "#EAE2ED", primaryColor: "#1F8A7E" },
  { name: "Mint + Red", backgroundColor: "#A9D3B4", primaryColor: "#C0271C" },
  { name: "Sky + Pink", backgroundColor: "#C9DEEA", primaryColor: "#C24B8E" },
  { name: "Taupe + Cobalt", backgroundColor: "#B0A69E", primaryColor: "#2E4EA8" },
  // Padding from COLOR_PRESETS to reach 18 (three full rows of six).
  { name: "Classic", backgroundColor: "#ffffff", primaryColor: "#000000" },
  { name: "Ocean", backgroundColor: "#e8f4f8", primaryColor: "#2b50e0" },
  { name: "Sunset", backgroundColor: "#fef3e2", primaryColor: "#ed3024" },
];

// Individual color options for custom selection
export const BACKGROUND_COLORS = [
  "#ffffff", // White
  "#f5f5f5", // Light Gray
  "#fafafa", // Off White
  "#e8f4f8", // Light Blue
  "#fef3e2", // Light Orange
  "#e8f5e9", // Light Green
  "#f3e5f5", // Light Purple
  "#fce4ec", // Light Pink
  "#e0f2f1", // Light Teal
  "#fffde7", // Light Yellow
  "#e3f2fd", // Light Sky Blue
  "#fbe9e7", // Light Coral
  "#1a1a1a", // Near Black
  "#2c3e50", // Dark Blue Gray
  "#1b5e20", // Dark Green
  "#4a148c", // Deep Purple
];

export const ACCENT_COLORS = [
  "#000000", // Black
  "#ffffff", // White
  "#2b50e0", // Blue
  "#ed3024", // Red
  "#2e7d32", // Green
  "#7b1fa2", // Purple
  "#c2185b", // Pink
  "#00695c", // Teal
  "#f9a825", // Yellow/Gold
  "#1565c0", // Dark Blue
  "#ff5722", // Deep Orange
  "#795548", // Brown
  "#607d8b", // Blue Gray
  "#e91e63", // Bright Pink
  "#009688", // Cyan
  "#ff9800", // Orange
];
